
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/error",
      function () {
        return require("private-next-pages/checkout/error.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/error"])
      });
    }
  